import { render } from "./bank-details.vue?vue&type=template&id=0f7d7b94"
import script from "./bank-details.vue?vue&type=script&lang=js"
export * from "./bank-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__